import { Text } from '@shared/components/Text';
import { LinkedCard } from '@shared/components/blocks/lib/cards';
import { grid } from '@shared/styles';

export function CardSelectItem({ card, testID }: { card: LinkedCard; testID?: string }) {
  return (
    <Text size="body1" style={{ paddingLeft: grid(1) }} testID={testID}>
      {card.name}
    </Text>
  );
}
